import { gettext } from '@bikemap/js/services'
import { startTutorial, setContent, showNextBtn, showSkipBtn, NEXT, focus, removeNextBtn } from '@bikemap/js/integrations/tutorial'

// Globals:
// @ts-ignore
const $ = window.$

function handleSkip(e) {
    $.outdoorish.markHintSeen('route_collections')
}

function* routeCollectionTutorial() {
    setContent(
        '<p>' + gettext('This is a route collection. Route collections are a great way to organize routes.') + '</p>' +
        '<p><strong>' + gettext("Let's walk through this screen and set up a cool collection in 5 quick steps.") + '</strong></p>'
    )
    showNextBtn(gettext("OK, let's go"))
    showSkipBtn(gettext('Skip'), handleSkip)
    yield NEXT
    focus('.title-container')
    setContent(
        '<p>' + gettext("First, let's set a meaningful title.") + '</p>' +
        '<p><strong>' + gettext("Enter a nice title and hit 'next'.") + '</strong></p>'
    )
    showNextBtn(gettext('Next'))
    yield NEXT
    focus('.collection-visibility')
    setContent(
        '<p>' + gettext('Beautiful.') + '</p>' +
        '<p><strong>' + gettext('Now choose a visibility setting for your collection.') + '</strong></p>' +
        '<p>' + gettext('Private collections can only be seen by you while public collections can be seen by all Bikemap users.') + '</p>'
    )
    yield NEXT
    focus('.stats')
    setContent(
        '<p>' + gettext('Lovely.') + '</p>' +
        '<p><strong>' + gettext('This area sums up various statistics of all routes within a collection.') + '</strong></p>' +
        '<p>' +
            '<em class="text-underlined">' + gettext('Pro tip') + ':</em>' +
            gettext('Watch the ascent value and make sure not to overestimate yourself when adding routes to your "Trans-Alps Crossing" collection... ;-)') +
        '</p>'
    )
    yield NEXT
    focus('#description-tags-wrapper')
    setContent(
        '<p>' + gettext('Adding a description text and some tags will help you to easily find and categorize your collection later.') + '</p>' +
        '<p><strong>' + gettext('Enter some description text and/or tags and hit "next".') + '</strong></p>'
    )
    yield NEXT
    focus('.change-preview-image')
    setContent(
        '<p>' + gettext('Gorgeous!') + '</p>' +
        '<p><strong>' + gettext('Make sure to add a title image that represents the beauty of your routes.') + '</strong></p>'
    )
    yield NEXT
    focus('.find-routes-wrapper')
    setContent(
        '<p>' + gettext("You're all set!") + '</p>' +
        '<p>' + gettext('The last thing to do is to add some routes.') + '</p>' +
        '<p><strong>' + gettext('Search for some routes and use the <em>Add to</em> button to add them to your collection.') + '</strong></p>'
    )
    removeNextBtn()
    showSkipBtn(gettext('End tutorial'), handleSkip)
}

/**
 * Initializes the tutorial functionality of a route collection page.
 * @param {boolean} [autoplay] Tutorial will start immediately, if this is true
 */
export function initTutorial(autoplay) {
    if (autoplay) startTutorial(routeCollectionTutorial)
    document.getElementById('button-tutorial').addEventListener('click', e => {
        e.preventDefault()
        startTutorial(routeCollectionTutorial)
    })
}
